module.exports = "<div class=\"lowy-toast\" *ngIf=\"visible\" [ngClass]=\"{opening: isOpen, closing: !isOpen}\" (click)=\"closeFast()\">\n    <div>{{message}}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/toast/toast.component.html
// module id = ./src/app/components/toast/toast.component.html
// module chunks = main